import "../Home/home.css";
import Header from "../../components/Header/Header";
import logo from "../../Assets/favicon.png";

import Home1 from "../../Assets/home-carousel/hdfc.webp";
import Home2 from "../../Assets/home-carousel/gcit.webp";
import Home3 from "../../Assets/home-carousel/IAS.webp";
import Home4 from "../../Assets/home-carousel/library.webp";
import Home5 from "../../Assets/home-carousel/reccaclub.webp";
import Home6 from "../../Assets/home-carousel/restobar.webp";
import Home7 from "../../Assets/home-carousel/T-hub.webp";
import Home8 from "../../Assets/home-carousel/sernity.webp";
import Home9 from "../../Assets/home-carousel/seimens.webp";

function Home() {
  return (
    <div>
      <Header />

      <div className="heading d-flex align-items-center justify-content-center gap-2">
        <img
          className="img-fluid logo-img"
          src={logo}
          alt="Acoustical Factory Logo"
          width="60"
          height="60"
        />
        <h1 className="home-heading">WELCOME ASI TEAM</h1>
      </div>

      <div className="heading-2 mt-5">
        <h2 className="home-heading">ADVANCED ACOUSTICAL INDUSTRY TOOLS</h2>
        <p>Empowering Your Growth in Manufacturing & Sales</p>
      </div>

      <div className="slider-wrapper">
        <div className="slider-container">
          <img
            src={Home1}
            alt="HDFC Acoustic Project"
            width="400"
            height="250"
            fetchpriority="high"
          />
          <img
            src={Home2}
            alt="GCIT Acoustic Installation"
            loading="lazy"
            width="400"
            height="250"
          />
          <img
            src={Home3}
            alt="IAS Acoustic Project"
            loading="lazy"
            width="400"
            height="250"
          />
          <img
            src={Home4}
            alt="Library Acoustic Solution"
            loading="lazy"
            width="400"
            height="250"
          />
          <img
            src={Home5}
            alt="Recca Club Acoustics"
            loading="lazy"
            width="400"
            height="250"
          />
          <img
            src={Home6}
            alt="Restobar Acoustic Design"
            loading="lazy"
            width="400"
            height="250"
          />
          <img
            src={Home7}
            alt="T-Hub Acoustic Space"
            loading="lazy"
            width="400"
            height="250"
          />
          <img
            src={Home8}
            alt="Serenity Acoustic Project"
            loading="lazy"
            width="400"
            height="250"
          />
          <img
            src={Home9}
            alt="Siemens Acoustic Facility"
            loading="lazy"
            width="400"
            height="250"
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
